import {
  SwapRightOutlined,
  SwapLeftOutlined,
  CloseOutlined,
  CheckOutlined,
} from "@ant-design/icons";
import { Button, Space, Popover } from "antd";
import { EditOutlined } from "@ant-design/icons";

export const columns = (
  lang: string,
  handleConfirm: any,
  warehouseList: any
) => {
  return [
    {
      title: lang === "en-US" ? "product name" : "نام محصول",
      dataIndex: "name",
      key: "name",
    },
    {
      // title: lang === "en-US" ? "quantity" : "تعداد",
      title:
        lang === "en-US" ? (
          <Space>
            <span>quantity</span>
            <EditOutlined />
          </Space>
        ) : (
          <Space>
            <span>تعداد</span>
            <EditOutlined />
          </Space>
        ),
      dataIndex: "quantity",
      key: "quantity",
      editable: true,
    },
    {
      title: lang === "en-US" ? "FromWarehouse" : "انبار مبدا",
      dataIndex: "fromWarehouse",
      key: "fromWarehouse",
      render: (source: number) => (
        <>
          {warehouseList.find((warehouse: any) => warehouse.id === source)
            ? warehouseList.find((warehouse: any) => warehouse.id === source)
                .name
            : "--"}
        </>
      ),
    },

    {
      title: lang === "en-US" ? "Transfer to " : " انتقال به ",
      dataIndex: "Transfer",
      key: "Transfer",
      render: () => (
        <>
          {lang === "en-US" ? (
            <SwapRightOutlined style={{ fontSize: 42, color: "#1890ff" }} />
          ) : (
            <SwapLeftOutlined style={{ fontSize: 42, color: "#1890ff" }} />
          )}
        </>
      ),
    },
    {
      title: lang === "en-US" ? "ToWarehouse " : "انبار مقصد",
      dataIndex: "toWarehouse",
      key: "toWarehouse",
      render: (source: number) => (
        <>
          {warehouseList.find((warehouse: any) => warehouse.id === source)
            ? warehouseList.find((warehouse: any) => warehouse.id === source)
                .name
            : "--"}
        </>
      ),
    },
    {
      title: lang === "en-US" ? "ََStatus Selection" : " انتخاب وضعیت",
      dataIndex: "id",
      key: "id",
      render: (id: string) => (
        <Space style={{ alignItems: "center" }}>
          <Popover
            content={lang === "en-US" ? "Approve " : " قبول کردن"}
            trigger="hover"
          >
            <Button
              style={{
                backgroundColor: "#34BE82",
                border: "none",
                color: "white",
              }}
              onClick={() => handleConfirm(true, id)}
            >
              <CheckOutlined />
            </Button>
          </Popover>
          <Popover
            content={lang === "en-US" ? "DisApprove" : "رد کردن"}
            trigger="hover"
          >
            <Button
              style={{
                backgroundColor: "#D82148",
                border: "none",
                color: "white",
              }}
              onClick={() => handleConfirm(false, id)}
            >
              <CloseOutlined />
            </Button>
          </Popover>
        </Space>
      ),
    },
  ];
};

export const dataSource = (res: any) => {
  const newData = res.map((item: any, index: number) => {
    return {
      ...item,
      key: index,
      fromWarehouse: item.fromWarehouse,
      toWarehouse: item.toWarehouse,
    };
  });
  return newData;
};
